import React, {Component, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import {Nullable} from '../../app/TypeHelpers'
import AssocManagementRepository from './AssocManagementRepository'
import {Information} from '../../network/response/Information'
import {formatDateLocal} from '../../formatters/formatMoment'
import {AssocOfCondominium} from './model/AssocOfCondominium'
import {AdminAssocTermForm, AdminAssocTermFormState} from './components/AdminAssocTermForm'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    location: Location<RegisterAssocTermLocationState>
    assocManagementRepo: AssocManagementRepository
}

export interface RegisterAssocTermLocationState {
    assocList: AssocOfCondominium[],
    selectedAssocId: number,
}

class AdminRegisterAssocTermPage extends Component<Props & AdminPagePropsSet> {
    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        const {
            assocList,
            selectedAssocId,
        } = props.location.state

        if (!assocList) {
            throw Error('管理組合リストが渡されていない')
        }

        if (assocList.length === 0) {
            throw Error('渡された管理組合リストの中身がない')
        }

        if (!selectedAssocId) {
            throw Error('処理対象の管理組合IDが渡されていない')
        }
    }

    handleClickPreviousPage = () => {
        this.props.navigate(
            `/admin/condominiums/${this.props.condominiumCd}/assoc-terms`,
        )
    }

    handleClickSubmit = async (state: AdminAssocTermFormState) => {
        const {
            condominiumCd,
            assocManagementRepo,
            asyncCallFunction,
            navigate,
            location,
            eventEmitter,
        } = this.props

        const {
            assocTermName,
            assocTermStartDate,
            assocTermEndDate,
        } = state

        if (assocTermStartDate === null || assocTermEndDate === null) {
            return
        }

        await eventEmitter.showLoading()
        try {
            const informations: Nullable<Information[]> = await asyncCallFunction(
                // @ts-ignore
                assocManagementRepo.registerAssocTerm.bind(
                    assocManagementRepo,
                    condominiumCd,
                    Number(location.state.selectedAssocId),
                    assocTermName,
                    formatDateLocal(assocTermStartDate),
                    formatDateLocal(assocTermEndDate),
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(eventEmitter)
                },
            )

            if (informations === null) {
                return
            }

            navigate(
                `/admin/condominiums/${condominiumCd}/assoc-terms`,
                {
                    state: {
                        selectedAssocId: location.state.selectedAssocId,
                        information: informations[0],
                    },
                },
            )
        } finally {
            eventEmitter.closeLoading()
        }
    }

    render(): ReactNode {
        const {
            condominiumCd,
            eventEmitter,
        } = this.props
        const {
            assocList,
            selectedAssocId,
        } = this.props.location.state

        return <>
            <AdminAssocTermForm
                condominiumCd={condominiumCd}
                assocList={assocList}
                selectedAssocId={selectedAssocId}
                handleClickPreviousPage={this.handleClickPreviousPage}
                handleClickSubmit={this.handleClickSubmit}
                eventEmitter={eventEmitter}
            />
        </>
    }
}

export default createAdminPage(AdminRegisterAssocTermPage)
